export const limit: number = 30; //how many venues will be returned in single query
export const skip: number = 30 //how many venues will be skiped in single query